export default Array.isArray;



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/isArray.js
// module id = 621
// module chunks = 0